import { css } from "@emotion/react";
import { memo, useState } from "react";
import { Yokai } from "../../../consts";

type YokaiCardProps = {
  yokai: Yokai;
  isLeft?: boolean;
};

const YokaiCard: React.FC<YokaiCardProps> = ({ yokai, isLeft = false }) => {
  const [target, setTarget] = useState(0);
  const dirName = yokai.default.name.toLowerCase();
  return (
    <div
      css={[
        css`
          position: relative;
          width: 100%;
          max-width: 790px;
          height: 430px;
          background-color: #fff;
          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
        `,
        isLeft
          ? css`
              margin-left: auto;
            `
          : null,
      ]}
    >
      <div
        css={[
          css`
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            padding: 32px;
            background-image: ${target === 0
              ? "url('/img/youkai/" + dirName + "/normal.png')"
              : "url('/img/youkai/" +
                dirName +
                "/" +
                yokai.artist[target - 1].icon +
                ".png')"};
            background-repeat: no-repeat;
            background-size: contain;
            @media screen and (max-width: 1024px) {
              background-size: cover;

              &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(255, 255, 255, 0.5);
              }
            }
          `,
          isLeft
            ? css`
                background-position: right;
                justify-content: flex-start;
              `
            : css`
                background-position: left;
                justify-content: flex-end;
              `,
        ]}
      >
        <div
          css={css`
            max-width: 380px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            @media screen and (max-width: 1024px) {
              z-index: 1;
            }
          `}
        >
          <h3
            css={[
              css`
                font-family: "Bebas Neue", cursive;
                font-size: 28px;
                font-weight: 300;
              `,
              isLeft
                ? css`
                    text-align: left;
                  `
                : css`
                    text-align: right;
                  `,
            ]}
          >
            {target === 0 ? yokai.default.name : yokai.artist[target - 1].name}
          </h3>
          <p
            css={css`
              text-align: justify;
              max-height: 82%;
              overflow: auto;
            `}
          >
            {target === 0 ? yokai.default.text : yokai.artist[target - 1].text}
          </p>
        </div>
        <img
          css={[
            css`
              position: absolute;
              top: 0;
            `,
            isLeft
              ? css`
                  left: 0;
                `
              : css`
                  right: 0;
                `,
          ]}
          src={
            target === 0
              ? `/img/youkai/${dirName}/text.png`
              : `/img/youkai/${dirName}/${yokai.artist[target - 1].nameImg}.png`
          }
          alt={dirName}
        />
      </div>
      <div
        css={[
          css`
            position: absolute;
            width: 70px;
            height: 70px;
            display: flex;
            flex-direction: column;
            gap: 8px;
            top: 0;

            & > button {
              padding: 5px;
              border: none;
              transition: opacity 0.3s;
              cursor: pointer;

              &:hover {
                opacity: 0.6;
              }
            }

            @media screen and (max-width: 1024px) {
              flex-direction: row;
              position: relative;
              width: 100%;

              & > button img {
                max-width: 55px;
              }
            }
          `,
          isLeft
            ? css`
                left: -70px;
                & > button {
                  border-radius: 0 0 0 30px;
                }

                @media screen and (max-width: 1024px) {
                  left: auto;
                  right: 0;
                  justify-content: flex-end;
                }
              `
            : css`
                right: -70px;

                & > button {
                  border-radius: 0 0 30px 0;
                }
                @media screen and (max-width: 1024px) {
                  left: 0;
                  right: auto;
                  justify-content: flex-start;
                }
              `,
        ]}
      >
        <button
          css={
            target === 0
              ? css`
                  background-color: #e63c3c;
                `
              : css`
                  background-color: #873633;
                `
          }
          onClick={() => setTarget(0)}
        >
          <img src="/img/yako_icon.png" alt="YAKO" />
        </button>
        {yokai.artist.map((p, i) => (
          <button
            key={p.icon}
            onClick={() => setTarget(i + 1)}
            css={
              target === i + 1
                ? css`
                    background-color: #e63c3c;
                  `
                : css`
                    background-color: #873633;
                  `
            }
          >
            <img src={`/img/artist/${p.icon}.png`} alt={p.icon} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default memo(YokaiCard);
